"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var base = 8;
var unit = 'px';
var spacing = {
  xxsmall: base / 2 + unit,
  xsmall: base + unit,
  small: base * 2 + unit,
  medium: base * 3 + unit,
  large: base * 4 + unit,
  xlarge: base * 5 + unit,
  xxlarge: base * 7 + unit
};
var _default = spacing;
exports["default"] = _default;